import SearchDropdown from '../../global-components/searchDropdown';
import SearchInput from '../../SearchInput';
import './AnnouncementFilters.scss';

export interface AnnouncementType {
  label: string;
  value: string;
}

interface Props {
  search: string;
  onChangeSearch: (newValue: string) => void;
  typeValue: string;
  onChangeType: (newType: string) => void;
  types: AnnouncementType[];
  onClickFilter: () => void;
}

export default function AnnouncementFilters({
  search,
  onChangeSearch,
  typeValue,
  onChangeType,
  types,
}: Props) {
  return (
    <div className='AnnouncementFilters'>
      <SearchInput
        value={search}
        onChange={onChangeSearch}
      />
      <SearchDropdown
        className='SearchDropdown'
        id='announcement-filters-type'
        label='Type'
        placeholder='All'
        dummyOptionText='All'
        selectedValue={typeValue}
        options={types}
        onSelect={(announcementType: AnnouncementType) => {
          onChangeType(announcementType.value);
        }}
      />
    </div>
  );
}
